import computedForecastStock from './ComputeForecastStock';
import getChartBorder from './getChartBorder';
import getStyleAndColor from './GetStyleAndColor';

export default {
  computedForecastStock,
  getStyleAndColor,
  getChartBorder,
};
